{
    "image_upload_error": "Gagal mengunggah gambar. Coba muat ulang halaman ini dan pilih gambar lagi.",
    "search_placeholder": "Mencari foto dan ilustrasi",
    "search": "Temukan",
    "photo": "Gambar",
    "image_by": "oleh",
    "free_photos_from": "Gambar stok gratis dari",
    "uploading": "Mengunggah",
    "cancel": "Batal",
    "select": "Pilih"
}
